import React from 'react';
import { cn } from '../utils/cn';

const AlertAccent = ({ title, text, showAlert, children, classContainer }) => {
  return (
    <>
      {showAlert ? (
        <>
          <div className={cn('px-4 py-3 leading-normal text-white bg-orange-500 hover:bg-orange-600 rounded-3xl cursor-pointer', classContainer)} role="alert">
            <p className="font-bold">{title}</p>
            <p>{text}</p>
            {children && children}
          </div>
        </>
      ) : null}
    </>
  );
};

export default AlertAccent;
